import { render, staticRenderFns } from "./Registro_mobile.vue?vue&type=template&id=ed676e3e&"
import script from "./Registro_mobile.vue?vue&type=script&lang=js&"
export * from "./Registro_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Registro_mobile.vue?vue&type=style&index=0&id=ed676e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports